import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/style.css';

// ✅ Import AOS and its styles
import AOS from 'aos';
import 'aos/dist/aos.css';

// ✅ Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// ✅ Import @vueuse/head for per-page SEO meta tags
import { createHead } from '@vueuse/head';

const app = createApp(App);
const head = createHead();

app.use(router);
app.use(head);
app.mount('#app');
AOS.init();